import React, { Component } from "react";
import ImageGrid from '../components/image-grid';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Pagination from '../components/pagination';
import dispatcher from '../dispatcher.js';
import ImageStore from '../stores/image-store';

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			images: ImageStore.getImages(),
			hasBefore: ImageStore.getHasBefore(),
			hasNext: ImageStore.getHasNext(),
			lastIndex: ImageStore.getLastIndex(),
			searchMode: ImageStore.getSearchMode(),
			isLoading: true
		}
		this.onImageItemClick = this.onImageItemClick.bind(this);
		this.onGestioneUtenti = this.onGestioneUtenti.bind(this);
		this.loadImages = this.loadImages.bind(this);
		this.filterByBucket = this.filterByBucket.bind(this);
		this.nextPage = this.nextPage.bind(this);
		this.previousPage = this.previousPage.bind(this);
		this.searchImage = this.searchImage.bind(this);
		this.searchValue = '';
		this.searchDebounce = false;
	}

	componentDidMount() {
		ImageStore.on('change', this.loadImages);
		dispatcher.dispatch({
			type: 'getImages'
		});
	}

	loadImages() {
		this.setState({
			images: ImageStore.getImages(),
			hasBefore: ImageStore.getHasBefore(),
			hasNext: ImageStore.getHasNext(),
			lastIndex: ImageStore.getLastIndex(),
			searchMode: ImageStore.getSearchMode(),
			isLoading: false
		});
	}

	componentWillUnmount() {
		ImageStore.removeListener('change', this.loadImages);
	}

	onLogout() {
		dispatcher.dispatch({
			type: 'user_logout'
		});
	}

	onGestioneUtenti(utenti) {
		this.props.history.push('/gestione-utenti');
	}


	onImageItemClick(payload, event) {
		this.props.history.push(`/image/${payload.bucket}/${payload.uuid}`);
	}

	nextPage(event) {
		event.preventDefault();
		this.setState({
			isLoading: true
		}, () => {
			if(this.state.searchMode) {
				dispatcher.dispatch({
					type: 'searchImage',
					searchValue: this.searchValue,
					direction: "fw",
				});
			} else {
				dispatcher.dispatch({
					type: 'getImages',
					direction: 'fw',
				});
			}			
		});
	}

	previousPage(event) {
		event.preventDefault();
		if(this.state.searchMode) {
			dispatcher.dispatch({
				type: 'searchImage',
				searchValue: this.searchValue,
				direction: "bw",
			});
		} else {
			dispatcher.dispatch({
				type: 'getImages',
				direction: 'bw',
			});
		}
	}

	filterByBucket(filter) {
		dispatcher.dispatch({
			type: "setFilter",
			bucketFilter: filter
		});
		let payload = {}; 
		if(this.state.searchMode && this.searchValue.length) {
			payload.type = 'searchImage';
			payload.searchValue = this.searchValue;
			payload.offset = 0;
		} else if(filter.length) {
			payload.type = 'searchImage';
			payload.offset = 0;
		} else {
			payload.type = 'getImages';
		}
		dispatcher.dispatch(payload);
	}

	searchImage(event) {
		this.searchValue = event.target.value;
		if(this.searchDebounce)
		clearTimeout(this.searchDebounce);
		this.searchDebounce = setTimeout(() => {
			this.setState({
				isLoading: true
			}, () => {
				if( this.searchValue.length ) {
					dispatcher.dispatch({
						type: 'searchImage',
						searchValue: this.searchValue,
						offset: 0,
					})
				} else {
					dispatcher.dispatch({
						type: 'getImages'
					});					
				}
			})
		}, 300)
	}

	render() {
		return (
			<React.Fragment>
				<Header subtitle="Dashboard" logout={this.onLogout} authGroups={this.props.groups} onGestioneUtenti={this.onGestioneUtenti}/>
				<section className="section">
					<div className="columns">
						<div className="column is-three-quarters">
						{
							this.state.isLoading
							? <div style={{margin: '0 auto', width: '5em', height: '5em'}} className="loader"></div>
							: this.state.images.length ? <React.Fragment>
							<ImageGrid onImageClick={this.onImageItemClick} images={this.state.images}/>
							<Pagination hasBefore={this.state.hasBefore} onPrevPage={this.previousPage} onNextPage={this.nextPage} hasNext={this.state.hasNext}/>
							</React.Fragment> : <div>Nessuna immagine trovata.</div>
						}
						</div>
						<div className="column">
							<Sidebar filterFunction={this.filterByBucket} onChangeInput={this.searchImage}/>
						</div>
					</div>
				</section>
			</React.Fragment>
		)
	}
}

export default Dashboard


// WEBPACK FOOTER //
// ./src/views/dashboard.jsx